import InnerEmpty from './InnerEmpty';

export default InnerEmpty;
